import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.json.stringify.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-right-box"
  }, [_vm.typeIndex == 0 ? _c('div', {
    staticClass: "container-right-box-menu"
  }, [_c('div', {
    staticClass: "container-left-main-position-color"
  }), _c('div', {
    staticClass: "container-right-box-menu-wapper"
  }, [_c('div', {
    staticClass: "container-left-main-name-wapper"
  }, [_c('div', {
    staticClass: "container-left-main-name"
  }, [_vm._v("公告公文")]), _c('a', {
    class: _vm.loadings ? 'container-left-main-icon1' : 'container-left-main-icon',
    on: {
      "click": function click($event) {
        return _vm.handleLoading(0);
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("../assets/img/jiazai.png"),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "position-wapper"
  }, [_vm.showLoading2 ? _c('div', {
    staticClass: "container-left-main-position"
  }, [_c('a-spin')], 1) : _vm._e(), _c('div', {
    staticClass: "container-right-box-menu-title"
  }, [_c('div', {
    staticClass: "container-right-box-menu-title-left"
  }, [_c('a', {
    class: _vm.menuIndex == 1 ? 'container-right-box-menu-title-left-txt1' : 'container-right-box-menu-title-left-txt2',
    on: {
      "click": function click($event) {
        return _vm.changeMenuIndex(1);
      }
    }
  }, [_c('a-badge', {
    attrs: {
      "dot": _vm.ggDot
    }
  }, [_c('div', [_vm._v("通知公告")])])], 1), _c('a', {
    class: _vm.menuIndex == 0 ? 'container-right-box-menu-title-left-txt1' : 'container-right-box-menu-title-left-txt2',
    on: {
      "click": function click($event) {
        return _vm.changeMenuIndex(0);
      }
    }
  }, [_c('a-badge', {
    attrs: {
      "dot": _vm.gwDot
    }
  }, [_c('div', [_vm._v("最新公文")])])], 1), _c('a', {
    class: _vm.menuIndex == 2 ? 'container-right-box-menu-title-left-txt1' : 'container-right-box-menu-title-left-txt2',
    on: {
      "click": function click($event) {
        return _vm.changeMenuIndex(2);
      }
    }
  }, [_c('a-badge', {
    attrs: {
      "dot": _vm.tzDot
    }
  }, [_c('div', [_vm._v("系统通知")])])], 1)]), _c('a', {
    staticClass: "container-right-box-menu-title-right",
    on: {
      "click": _vm.toNewdocment
    }
  }, [_vm._v(" 查看更多 ")])]), _c('a-divider', {
    staticClass: "divider"
  }), _vm.menuIndex == 0 && _vm.allList ? _c('div', {
    staticClass: "container-right-box-menu-main-wapper"
  }, [JSON.stringify(_vm.zxgwList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._e(), _vm._l(_vm.zxgwList, function (items, index) {
    return _c('div', {
      key: index,
      staticClass: "container-right-box-menu-main",
      staticStyle: {
        "border": "0px"
      }
    }, [_c('a', {
      staticClass: "footer-menu-main-box",
      on: {
        "click": function click($event) {
          return _vm.toView(items);
        }
      }
    }, [_c('div', {
      staticClass: "footer-menu-main-center1"
    }, [_c('div', {
      staticClass: "footer-menu-main"
    }, [_vm._v(" " + _vm._s(items.fileName) + " ")])]), _c('div', {
      staticClass: "footer-menu-main-time"
    }, [_vm._v(" " + _vm._s(items.docTime.split(' ')[0]) + " ")])])]);
  })], 2) : _vm.menuIndex == 1 && _vm.allList ? _c('div', {
    staticClass: "container-right-box-menu-main-wapper"
  }, [JSON.stringify(_vm.tzggList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._e(), _vm._l(_vm.tzggList, function (items, index) {
    return _c('div', {
      key: index,
      staticClass: "container-right-box-menu-main",
      staticStyle: {
        "border": "0px"
      }
    }, [_c('a', {
      staticClass: "footer-menu-main-box",
      on: {
        "click": function click($event) {
          return _vm.toView1(items);
        }
      }
    }, [_c('div', {
      staticClass: "footer-menu-main-center1"
    }, [items.emergency == 1 ? _c('div', {
      staticClass: "footer-menu-main-center1-never",
      staticStyle: {
        "background-color": "#108ee9",
        "border": "1px solid #108ee9",
        "color": "#fff"
      }
    }, [_vm._v(" 常规 ")]) : items.emergency == 2 ? _c('div', {
      staticClass: "footer-menu-main-center1-service",
      staticStyle: {
        "background-color": "#cc0033",
        "border": "1px solid #cc0033",
        "color": "#fff"
      }
    }, [_vm._v(" 紧急 ")]) : items.emergency == 3 ? _c('div', {
      staticClass: "footer-menu-main-center1-service",
      staticStyle: {
        "background-color": "#70bbf2",
        "border": "1px solid #70bbf2",
        "color": "#fff"
      }
    }, [_vm._v(" 重要 ")]) : _vm._e(), _c('div', {
      staticClass: "footer-menu-main"
    }, [_vm._v(_vm._s(items.title))]), items.isTop == 1 ? _c('div', {
      staticClass: "footer-menu-main-center1-never1"
    }, [_vm._v(" 置顶 ")]) : _vm._e()]), _c('div', {
      staticClass: "footer-menu-main-time"
    }, [_vm._v(" " + _vm._s(items.releaseTime.split(' ')[0]) + " ")])])]);
  })], 2) : _vm.menuIndex == 2 && _vm.allList ? _c('div', {
    staticClass: "container-right-box-menu-main-wapper"
  }, [JSON.stringify(_vm.xttzList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._e(), _vm._l(_vm.xttzList, function (items, index) {
    return _c('div', {
      key: index,
      staticClass: "container-right-box-menu-main",
      staticStyle: {
        "border": "0px"
      }
    }, [_c('a', {
      staticClass: "footer-menu-main-box",
      on: {
        "click": function click($event) {
          return _vm.toView2(items);
        }
      }
    }, [_c('div', {
      staticClass: "footer-menu-main-center1"
    }, [items.noticeType == 1 ? _c('div', {
      staticClass: "footer-menu-main-center1-never"
    }, [_vm._v(" 通知 ")]) : items.noticeType == 2 ? _c('div', {
      staticClass: "footer-menu-main-center11-service"
    }, [_vm._v(" 公文 ")]) : items.noticeType == 3 ? _c('div', {
      staticClass: "footer-menu-main-center2-service"
    }, [_vm._v(" 报销 ")]) : items.noticeType == 4 ? _c('div', {
      staticClass: "footer-menu-main-center3-service"
    }, [_vm._v(" 报修 ")]) : items.noticeType == 5 ? _c('div', {
      staticClass: "footer-menu-main-center4-service"
    }, [_vm._v(" 表单 ")]) : _vm._e(), _c('div', {
      staticClass: "footer-menu-main",
      attrs: {
        "title": items.msgContent
      }
    }, [_vm._v(" " + _vm._s(items.msgContent) + " ")]), items.msgType == 1 ? _c('div', [items.status == 0 ? _c('a-tag', {
      staticClass: "tag-blue"
    }, [_vm._v(" 待阅 ")]) : _c('a-tag', {
      staticClass: "tag-green"
    }, [_vm._v("已阅")])], 1) : _c('div', [items.auditStatus != null ? _c('a-tag', {
      staticClass: "tag-green"
    }, [_vm._v(" 已办 ")]) : _vm._e(), items.auditStatus == null ? _c('a-tag', {
      staticClass: "tag-blue"
    }, [_vm._v(" 待办 ")]) : _vm._e()], 1)]), _c('div', {
      staticClass: "footer-menu-main-time"
    }, [_vm._v(" " + _vm._s(items.msgTime.split(' ')[0]) + " ")])])]);
  })], 2) : _vm._e()], 1)])]) : _vm._e(), _vm.typeIndex == 1 ? _c('div', {
    staticClass: "container-right-box-menu"
  }, [_c('div', {
    staticClass: "container-left-main-position-color"
  }), _c('div', {
    staticClass: "container-right-box-menu-wapper"
  }, [_c('div', {
    staticClass: "container-left-main-name-wapper"
  }, [_c('div', {
    staticClass: "container-left-main-name"
  }, [_vm._v("报修管理")]), _c('a', {
    class: _vm.loadings1 ? 'container-left-main-icon1' : 'container-left-main-icon',
    on: {
      "click": function click($event) {
        return _vm.handleLoading1();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("../assets/img/jiazai.png"),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "position-wapper"
  }, [_c('div', {
    staticClass: "container-right-box-menu-wapper"
  }, [_vm.showLoading3 ? _c('div', {
    staticClass: "container-left-main-position"
  }, [_c('a-spin')], 1) : _vm._e(), _c('div', {
    staticClass: "container-right-box-menu-title"
  }, [_c('div', {
    staticClass: "container-right-box-menu-title-left"
  }, [_c('a', {
    class: _vm.myIndex == 0 ? 'container-right-box-menu-title-left-txt1' : 'container-right-box-menu-title-left-txt2',
    on: {
      "click": function click($event) {
        return _vm.changeMyIndex(0);
      }
    }
  }, [_c('div', [_vm._v("我的报修")])])]), _c('a', {
    staticClass: "container-right-box-menu-title-right",
    on: {
      "click": _vm.toRepair
    }
  }, [_vm._v(" 查看更多 ")])]), _c('a-divider', {
    staticClass: "divider"
  }), _vm.myIndex == 0 ? _c('div', {
    staticClass: "container-right-box-menu-main-wapper"
  }, [JSON.stringify(_vm.serviceList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._l(_vm.serviceList, function (items, index) {
    return _c('div', {
      key: index,
      staticClass: "container-right-box-menu-main",
      staticStyle: {
        "border": "0px"
      },
      on: {
        "click": function click($event) {
          return _vm.toRepairsClick(items);
        }
      }
    }, [_c('a', {
      staticClass: "footer-menu-main-box"
    }, [_c('div', {
      staticClass: "footer-menu-main-center1"
    }, [_c('div', {
      staticClass: "footer-menu-main"
    }, [_vm._v(_vm._s(items.description))]), 0 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-grey",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 草稿 ")]) : _vm._e(), 1 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-blue",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 待受理 ")]) : _vm._e(), 2 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-blue",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 待派单 ")]) : _vm._e(), 3 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-blue",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 待接单 ")]) : _vm._e(), 4 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-blue",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 不受理 ")]) : _vm._e(), 5 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-blue",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 维修中 ")]) : _vm._e(), 6 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-blue",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 已完成 ")]) : _vm._e(), 7 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-green",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 待评价 ")]) : _vm._e(), 8 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-green",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 外部维修 ")]) : _vm._e(), 9 === items.repairsStatus ? _c('a-tag', {
      staticClass: "tag-green",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 补　录 ")]) : _vm._e()], 1), _c('div', {
      staticClass: "footer-menu-main-time"
    }, [_vm._v(_vm._s(items.reDate))])])]);
  })], 2) : _c('div', {
    staticClass: "container-right-box-menu-main-wapper"
  }, [JSON.stringify(_vm.applyList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._l(_vm.applyList, function (items, indexs) {
    return _c('div', {
      key: indexs,
      staticClass: "container-right-box-menu-main",
      staticStyle: {
        "border": "0px"
      },
      on: {
        "click": function click($event) {
          return _vm.toReimbursementClick(items);
        }
      }
    }, [_c('a', {
      staticClass: "footer-menu-main-box"
    }, [_c('div', {
      staticClass: "footer-menu-main-center1"
    }, [_c('div', {
      staticClass: "footer-menu-main"
    }, [_vm._v(" " + _vm._s(items.fillName) + " ")]), 0 === items.reimburseStatus ? _c('a-tag', {
      staticClass: "tag-grey",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 草稿 ")]) : _vm._e(), 1 === items.reimburseStatus ? _c('a-tag', {
      staticClass: "tag-blue",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 待审核 ")]) : _vm._e(), 2 === items.reimburseStatus ? _c('a-tag', {
      staticClass: "tag-green",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 通过 ")]) : _vm._e(), 3 === items.reimburseStatus ? _c('a-tag', {
      staticClass: "tag-red",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 不通过 ")]) : _vm._e(), 4 === items.reimburseStatus ? _c('a-tag', {
      staticClass: "tag-shallow-orange",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 审核中 ")]) : _vm._e(), 5 === items.reimburseStatus ? _c('a-tag', {
      staticClass: "tag-orange",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 驳回 ")]) : _vm._e(), 6 === items.reimburseStatus ? _c('a-tag', {
      staticClass: "tag-grey",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v(" 撤回 ")]) : _vm._e()], 1), _c('div', {
      staticClass: "footer-menu-main-time"
    }, [_vm._v(" " + _vm._s(items.createTime.split(' ')[0]) + " ")])])]);
  })], 2)], 1)])])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };